type PlaybackErrorProps = {
  errorMessage: string;
  errorType: 'network_error' | 'playback_failure';
};

type StreamEndProps = {
  endReason: string;
  listenTime: number;
};

type StreamStartProps = {
  playbackStartTime: number;
  streamInitTime: number;
};

type TrackingData = {
  item: {
    asset: {
      id: string;
      name?: string;
    };
  };
  station: {
    asset: TrackingData['item']['asset'];
    playedFrom?: number;
  };
};

type SocialShareDataProps = {
  reportingKey: string;
  name: string;
  platform: 'facebook' | 'x';
};

/**
 * Maps component props to data fields for Play/Pause events
 * Also is base payload for other analytics calls
 */
export function generatePlaylistRadioTrackingData({
  name,
  playedFrom,
  reportingKey,
  subId,
  songName,
}: {
  reportingKey: string;
  name?: string;
  playedFrom?: number;
  subId: number;
  songName: string;
}): TrackingData {
  return {
    item: {
      asset: {
        id: `playlist_radio|${reportingKey}`,
        name,
        ...(subId && {
          sub: {
            id: `song|${subId}`,
            name: songName,
          },
        }),
      },
    },
    station: {
      asset: {
        id: `playlist_radio|${reportingKey}`,
        name,
        ...(subId && {
          sub: {
            id: `song|${subId}`,
            name: songName,
          },
        }),
      },
      playedFrom,
    },
  };
}

export function getPlaylistRadioAnalyticsPayload(
  trackingData: TrackingData,
  data: PlaybackErrorProps | StreamEndProps | StreamStartProps,
): {
  item: TrackingData['item'];
  station: TrackingData['station'] &
    (PlaybackErrorProps | StreamEndProps | StreamStartProps);
} {
  return {
    ...trackingData,
    station: {
      ...trackingData.station,
      ...data,
    },
  };
}

/**
 * Maps component props to data fields for share event (e.g. FB share or X share)
 */
export function generateSocialShareTrackingData({
  name,
  platform,
  reportingKey,
}: SocialShareDataProps) {
  return {
    share: {
      platform,
    },
    station: {
      asset: {
        id: `playlist_radio|${reportingKey}`,
        name,
      },
    },
  };
}
